(function () {
    'use strict';

    angular
        .module('cog.shared')
        .directive('pendingDetail', pendingDetail);

    /* @ngInject */
    function pendingDetail(WAGER_CONST, appSettings, BET_TYPES, $filter) {

        var directive = {
            link: link,
            restrict: 'AE',
            templateUrl: appSettings.sharedPath + 'directives/pending-detail-directive.tmpl.html',
            scope: {
                wg: '=',
                container: '@',
                timezone: '@',
                mobileAmountDisplay: '<'
            },
            controller: pendingDirectiveController,
            controllerAs: 'vm',
        };
        return directive;

        function link($scope, $element) {
        }
    }

    /* @ngInject */
    function pendingDirectiveController($scope, appSettings, $filter, BET_TYPES, CogApiServiceProvider: ICogApiServiceProvider, $mdDialog, $mdToast, customerGameSelection: ICustomerSelection, PendingWagerTransformer: IPendingWagerTransformer, notificationService: INotificationService, $window, horseData) {
        var vm = this;
        vm.HeaderDescription = HeaderDescription;
        vm.DetailDescription = DetailDescription;
        vm.IfBetType = IfBetType;
        vm.PitcherDescription = PitcherDescription;
        vm.OutcomeLeg = OutcomeLeg;
        vm.CollapseBet = CollapseBet;
        vm.CollapseDetail = CollapseDetail;
        vm.FinalScore = FinalScore;
        vm.FullDate = FullDate;
        vm.currency = appSettings.currency;
        vm.currencyDecimals = appSettings.currencyDecimals;
        vm.getBetCode = getBetCode;
        vm.deleteWager = deleteWager;
        vm.fillSpot = fillSpot;
        vm.isBM = CogApiServiceProvider.is_BM();
        vm.TeamDescription = TeamDescription;
        vm.shortPeriod = shortPeriod;
        vm.logo = setLogo;
        vm.TeamDescriptionLeg = TeamDescriptionLeg;
        vm.isLand = false;
        vm.isDesktop = ($window.orientation==null)?true:false;
        vm.getHorseHeader = getHorseHeader;
        vm.HorseDetail = HorseDetail;
        vm.timeZone = $scope.timezone ? (($scope.timezone=="ET")?'(EST)':'(' + $scope.timezone + ')') : '';
        vm.ContainerACC = ($scope.container == 'ACC')?true:false;
        vm.mobileAmountDisplay = ($scope.mobileAmountDisplay!=null && ($scope.mobileAmountDisplay.toLowerCase()=='risk' || $scope.mobileAmountDisplay.toLowerCase()=='win'))?$scope.mobileAmountDisplay.toLowerCase():null;
        $scope.PDTYPE = PendingWagerSymbol;

        activate();

        function activate() {
            vm.isLand = getOrientation();
        }

        function HeaderDescription(details) {
            var desc = "";
            /*if (details.WagerType == "M")
                desc = "";*/
            if (details.WagerType == PendingWagerSymbol.TYPE_SPREAD)
                desc = FormatPoints(details.Points, false);
            if (details.WagerType == PendingWagerSymbol.TYPE_TOTAL) {
                var isProps = isProp(details);
                if (!isProps)
                    desc = details.PointsOU.toLowerCase() + FormatPoints(details.Points, true);
                else {
                    if (details.Points>1) {
                        desc = details.PointsOU.toLowerCase() + FormatPoints(details.Points, true);
                    } else {
                        desc = (details.PointsOU=='O')?'(Yes)':'(No)';
                    }
                }
            }
            if (details.WagerType == PendingWagerSymbol.TYPE_TEAM_TOTAL)
                desc = details.PointsOU.toLowerCase() + FormatPoints(details.Points, true);
            return desc;
        }
        
        function isProp(details) {
            return (details && details.LeagueTypeName && details.LeagueTypeName.toLowerCase() == 'props')?true:false;
        }

        function PitcherDescription(details) {
            var Pitcher1 = "", Pitcher2 = "";

            //if (details.ListedPitcher1 != "") {
            Pitcher1 += WagerPitcherDescription(details.WagerType, details.ListedPitcher1, details.Pitcher1Required, details.AdjustableOddsFlag);
            Pitcher2 += WagerPitcherDescription(details.WagerType, details.ListedPitcher2, details.Pitcher2Required, details.AdjustableOddsFlag);
            //}

            if (Pitcher1 != "")
                return Pitcher1 + ", " + Pitcher2;
            else
                return "(Fixed) (Fixed)";
        }

        function FormatPoints(points, isTotal) {
            if (points == 0)
                return "pk";
            else {
                if (points > 0 && !isTotal)
                    points = "+" + points;

                //if (points.toString().startsWith("+0.") || points.toString().startsWith("-0.") || points.toString().startsWith("0.")) {
                if (points.toString().substring(0, 3) == "+0." || points.toString().substring(0, 3) == "-0." || points.toString().substring(0, 2) == "0.") {

                    if (!isTotal) {
                        if (points > 0)
                            return "+\u00BD ";
                        else
                            return "-\u00BD ";
                    }
                    else
                        return "\u00BD ";
                }
                if (points.toString().indexOf(".") > 0)
                    return points.toString().substring(0, points.toString().indexOf(".")) + "\u00BD";
            }
            return points;
        }

        function DetailDescription(details) {
            var strDesc = "";
            if (details.SportSubTypeWeb != null && details.SportSubTypeWeb != "") {
                strDesc = details.SportType;
                if (details.LeagueName != null)
                    strDesc += " - " + details.LeagueName;
                if (details.LeagueTypeName != null)
                    strDesc += " - " + details.LeagueTypeName;
                if (details.ContestDesc != null && details.ContestDesc != "") {
                    strDesc += " - Contest Wager";
                }
                else {
                    strDesc += " (#" + details.Rotation + ")";
                }
            }
            return strDesc;
        }

        function IfBetType(ContinueOnPush) {
            if (ContinueOnPush)
                return "if-win-or-push";
            else
                return "if-win-only";
        }

        function WagerPitcherDescription(wagerType, listedPitcher, pitcherReqFlag, adjustableOddsFlag) {
            var returnStr = " ";

            if (pitcherReqFlag)
                returnStr += listedPitcher + " (Listed)";
            else {
                if (wagerType == PendingWagerSymbol.TYPE_MONEY_LINE && adjustableOddsFlag)
                    returnStr += listedPitcher + " (Action)";
                else
                    returnStr += "(Fixed)";
            }
            return returnStr;
        }

        function OutcomeLeg(OutCome) {
            var val = "";
            if (OutCome != PendingWagerSymbol.OUTCOME_PENDING) {
                if (OutCome == PendingWagerSymbol.OUTCOME_WIN) val = "Win";
                if (OutCome == PendingWagerSymbol.OUTCOME_LOSS) val = "Loss";
                if (OutCome == PendingWagerSymbol.OUTCOME_CANCELLED) val = "Cancelled";
            }
            return val;
        }

        function CollapseBet(open, ticket, wagernumber) {
            if (open)
                $(".dtl_" + ticket + "_" + wagernumber).removeClass("ng-hide");
            else
                $(".dtl_" + ticket + "_" + wagernumber).addClass("ng-hide");
        }

        function CollapseDetail(index, ticket, wagernumber) {
            if ($("#dtl_" + ticket + "_" + wagernumber + "_" + index).hasClass("ng-hide"))
                $("#dtl_" + ticket + "_" + wagernumber + "_" + index).removeClass("ng-hide");
            else
                $("#dtl_" + ticket + "_" + wagernumber + "_" + index).addClass("ng-hide");
        }

        function FinalScore(details) {
            // scores
            var Team1Score = details.Team1Score;
            var Team2Score = details.Team2Score;
            var WinTeamScore = Team1Score; // assume Team1 is winner
            var LoseTeamScore = Team2Score;
            // teams name
            var Team1Desc = ((details.Team1Mascot != "") ? details.Team1Mascot : details.Team1);
            var Team2Desc = ((details.Team2Mascot != "") ? details.Team2Mascot : details.Team2);
            var WinTeamDesc = Team1Desc; // assume Team1 is winner
            var LoseTeamDesc = Team2Desc;

            // check team winner 
            if (Team1Score < Team2Score) {
                WinTeamScore = Team2Score;
                LoseTeamScore = Team1Score;
                WinTeamDesc = Team2Desc;
                LoseTeamDesc = Team1Desc;
            }
            // over text
            var overStr: string = (WinTeamDesc != "" && LoseTeamDesc != "") ? "over" : "";
            return `${WinTeamDesc} ${WinTeamScore}-${LoseTeamScore} ${overStr} ${LoseTeamDesc}`;
        }

        function FullDate(input) {
            if ($scope.container != 'CUST') {
                let dt:string = $filter('date')(input, 'MM/dd/yyyy');
                let tm:string = $filter('date')(input, 'hh:mm a');
                return "<span class='wgDateVal'>"+dt+"</span> <span class='wgTimeVal'>"+tm+"</span>";
            } else {
                // keep CUST with no span tags which has css defined
                return $filter('date')(input, 'MM/dd/yyyy hh:mm a');
            }
        }

        function getBetCode(BetTypeDesc) {
            var strCode = "";
            angular.forEach(BET_TYPES, function (value, key) {
                if (value.desc.toUpperCase() === BetTypeDesc.toUpperCase())
                    strCode = value.type;
            });
            return strCode;
        }

        function deleteWager(pendingWager: any) {

            if (pendingWager.AllowDelete && $scope.container != 'CUST') {
                var TicketNumber = pendingWager.TicketNumber;
                var WagerNumber = pendingWager.WagerNumber;
                var wagerHeaderDesc = '';
                var wagerOdds = '';
                var isFreeplay = (pendingWager.Details[0].IsFreePlay) ? 'Freeplay' : '';
                var wagerAmt = (pendingWager.TotalRisk < pendingWager.TotalWin) ? pendingWager.TotalRisk : pendingWager.TotalWin;
                var wagerDesc = (pendingWager.Type != 'Straight' && pendingWager.Type != 'Contest') ? pendingWager.Description : pendingWager.Details[0].Description;
                if (pendingWager.Type == 'Straight' || pendingWager.Type == 'Contest') {
                    wagerHeaderDesc = HeaderDescription(pendingWager.Details[0]);
                    wagerOdds = '(' + pendingWager.Details[0].OddsFormatted + ')';
                }
                var wagerTextContent = wagerDesc + ' ' + wagerHeaderDesc + ' ' + wagerOdds + ' $' + wagerAmt;
                if ($scope.container == 'ACC') {
                    notificationService.notify_onDeleteWager(pendingWager);
                } else {
                    // show confirm modal
                    var confirm = $mdDialog.confirm()
                        .title('Delete Wager')
                        .textContent(wagerTextContent)
                        .ariaLabel('Delete Wager')
                        .ok('Delete')
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function () {
                        //console.log(TicketNumber + ' ' + WagerNumber);
                        vm.loader = true;
                        // request delete wager & on complete refresh pending wagers & show toast wager deleted

                        let xOnAfterDelete = function (pResult) {
                            let msg: string = '';
                            if (pResult)
                                msg = 'Wager ' + wagerTextContent + ' - Deleted';
                            else
                                msg = 'Could not Delete wager';
                            notificationService.notify_MSG_BM_RELOAD_PENDING();
                            $mdToast.show({ template: '<md-toast><span flex>' + msg + '</span></md-toast>', position: 'bottom right', hideDelay: 3000 });
                        };
                        if ($scope.container == 'BM') {
                            var BMService: IBMService = CogApiServiceProvider.apiAccService();
                            BMService.deletePendingWager(TicketNumber, WagerNumber)
                                .success(function (response: any) {
                                    xOnAfterDelete(response == true);
                                })
                                .error(function (error) {
                                }).finally(function () {
                                    vm.loader = false;
                                });
                        } 
                    }, function () {
                        // do nothing
                    });
                }
            }
        }

        function fillSpot(pending: PendingItem) {
            if (pending.Outcome.toLowerCase() == 'open') {
                var pending_item: PendingItem = PendingWagerTransformer.transformItem(pending);
                if (pending_item.WagerType != null) {
                    vm.loader = true;
                    var pendingPromise: ng.IPromise<{}> = CogApiServiceProvider.apiAccService().openBetDetails(pending_item.TicketNumber, pending_item.WagerNumber);
                    pendingPromise.then(function (response: BetOpenCard) {
                        var openBetData: IOpenBetDetail = PendingWagerTransformer.transformOpenBetDetail(response);
                        openBetData.NeedConfirmation = response.NeedConfirmation;
                        vm.loader = false;
                        customerGameSelection.gameSelections.Clear();
                        CogApiServiceProvider.setBetType(BET_TYPES[openBetData.BetType]);
                        customerGameSelection.openSpots.setfillSpotData(openBetData);
                        if (vm.isBM) {
                            notificationService.notify_goBMBetTypeSchedule(openBetData.BetType);
                        } else {
                            notificationService.notify_goBetTypeSchedule(openBetData.BetType, false);
                        }
                    });
                } else {
                    // shouldn happen
                    console.log('tp err');
                }
            }
        }

        // COG-608
        function TeamDescription(wager: any, useMascot: boolean) {
            var strTeam: string = wager.Details[0].Description;
            /*** Mascot ***/
            if (!vm.isBM) {
                // total split 2 lines
                if (wager.Details[0].WagerType == PendingWagerSymbol.TYPE_TOTAL) {
                    // with Mascot
                    if (wager.Details[0].Team1Mascot != "" && wager.Details[0].Team2Mascot != "" && useMascot) {
                        strTeam = wager.Details[0].Team1Mascot + "<br>" + wager.Details[0].Team2Mascot;
                    } 
                    // no Mascot
                    else {
                        if (wager.Details[0].Team1 != "" && wager.Details[0].Team2 != "") {
                            strTeam = trimTeamDesc(wager.Details[0].Team1) + "<br>" + trimTeamDesc(wager.Details[0].Team2);
                        } else {
                            if (wager.Description == 'Total') {
                                var temp = wager.Details[0].Description.split("/");
                                if (temp.length > 1) {
                                    strTeam = trimTeamDesc(temp[0]) + "<br>" + trimTeamDesc(temp[1]);
                                }
                            }
                        }
                    }                    
                }
                if (wager.Details[0].WagerType !== "L" && wager.Details[0].Team1Mascot != "" && wager.Details[0].Team2Mascot != "") {
                    if (wager.Details[0].WagerType == "M" && strTeam.indexOf("Draw (") != -1) {
                        //nada
                    } else {
                        if (strTeam == wager.Details[0].Team1)
                            //strTeam = wager.Details[0].Team1Mascot;
                            strTeam = (wager.Details[0].Team1Mascot!=null && wager.Details[0].Team1Mascot!="")?wager.Details[0].Team1Mascot:wager.Details[0].Team1;
                        else
                            //strTeam = wager.Details[0].Team2Mascot;
                            strTeam = (wager.Details[0].Team2Mascot!=null && wager.Details[0].Team2Mascot!="")?wager.Details[0].Team2Mascot:wager.Details[0].Team2;
                    }
                }
            }
            /*** Mascot ***/
            var idxAlt = strTeam.indexOf(" Alt Line");
            if (idxAlt > 0)
                strTeam = strTeam.substring(0, idxAlt);
            if (wager.Description == 'Team Total') {
                strTeam += "<br>";
                strTeam += " <span class='tmTotal'>Team Total</span>";
            }
            return strTeam;
        }   

        function trimTeamDesc(TeamName) {
            var TeamNameLen = TeamName.length;
            if (TeamNameLen>33) {
                TeamName = TeamName.substring(0,30)+"...";
            }
            return TeamName;
        }

        $scope.formatRegulationNote = (note) => {
            if (!vm.isLand && !vm.isDesktop) {
                if (note.toLowerCase()=="regulation only") {
                    note = "Reg.Only";
                }
            }
            return note;
        }        

        function shortPeriod(strPeriod: string) {
            var period = " - ";
            if (strPeriod.length > 0) {
                var temp = strPeriod.split(" ");
                if (temp.length == 2 || temp.length == 3) {
                    switch (temp[0]) {
                        case "1st":
                            period += "1st";
                            break;
                        case "2nd":
                            period += "2nd";
                            break;
                        case "3rd":
                            period += "3rd";
                            break;
                        case "4th":
                            period += "4th";
                            break;
                    }
                    switch (temp[1]) {
                        case "Half":
                            period += " H";
                            break;
                        case "Period":
                            period += " P";
                            break;
                        case "5":
                            period += " Five";
                            break;
                        case "Quarter":
                            period += " Q";
                            break;
                    }
                }
            }
            if (!vm.isBM)
                return period;
            else
                return strPeriod;
        }

        function setLogo(detail) {
            var league = detail.IdLeague;
            var logo = (detail.Description == detail.Team1) ? detail.Team1Logo : detail.Team2Logo;
            var logoLeague = (league != null && angular.isNumber(league) && league > 0) ? ("lg" + league.toString()) : "";
            var logoTeam = (logo != null && angular.isNumber(logo) && logo > 0) ? ("l" + logo.toString()) : "";
            return (logoLeague != "" && logoTeam != "") ? (logoLeague + " " + logoTeam) : "";
        }

        function TeamDescriptionLeg(leg: any, useMascot: boolean) {
            var strTeam: string = leg.Description;
            var hasMascot = false;
            /*** Mascot ***/
            if (!vm.isBM && useMascot) {
                if (leg.WagerType == PendingWagerSymbol.TYPE_TOTAL && leg.Team1Mascot != "" && leg.Team2Mascot != "") {
                    strTeam = leg.Team1Mascot + "/" + leg.Team2Mascot;
                    hasMascot = true;
                }
                if (leg.WagerType !== "L" && leg.Team1Mascot != "" && leg.Team2Mascot != "") {
                    if (leg.WagerType == "M" && strTeam.indexOf("Draw (") != -1) {
                        //nada
                    } else {
                        if (strTeam == leg.Team1)
                            strTeam = leg.Team1Mascot;
                        else
                            strTeam = leg.Team2Mascot;
                    }
                }
            }
            /*** Mascot ***/
            var idxAlt = strTeam.indexOf(" Alt Line");
            if (idxAlt > 0)
                strTeam = strTeam.substring(0, idxAlt);
            if (strTeam.length>=25)
                strTeam = strTeam.substring(0,25)+"...";                
            return strTeam;
        }

        function getHorseHeader(horseDesc) {
            if(horseDesc != undefined && horseDesc.length > 0) {
                if(horseDesc.indexOf('PARLAY') < 0) {
                    var racenum = horseDesc.substring(12,15);
                    racenum = racenum.substring(0,racenum.indexOf(" "));
                    var bet = horseDesc.substring(14,horseDesc.indexOf("USD")-1);
                    return horseData.getTrackName(horseDesc.substring(7,10)) + " Race " + racenum + " - $" + bet;
                }
                else {
                    var bet = horseDesc.substring(7,horseDesc.indexOf("USD")-1);
                    var betType = horseDesc.substring(horseDesc.indexOf("USD") + 4,horseDesc.indexOf("PARLAY")-1);
                    return "RACEBOOK " + horseData.getBetType(betType) + " " + horseDesc.substring(horseDesc.indexOf("USD") + 7,horseDesc.indexOf("PARLAY") + 6) + " - $" + bet;
                }
            }
            return "";
        }

        function HorseDetail(horseDesc) {
            var arrDesc = [];
            if(horseDesc != undefined && horseDesc.length > 0) {
                if(horseDesc.indexOf('PARLAY') < 0) {
                    var betType = horseDesc.substring(horseDesc.indexOf("USD") + 4);
                    betType = betType.substring(0,betType.indexOf(" "));
                    arrDesc.push(horseData.getBetType(betType) + " [ " + horseDesc.substring(horseDesc.indexOf(betType) + betType.length + 1) + " ]");
                }
                else {
                    var arrSel = horseDesc.substring(horseDesc.indexOf("PARLAY") + 7).split(",");
                    angular.forEach(arrSel,function(value,key){
                        var track = horseData.getTrackName(value.substring(0,3));
                        var racenum = value.substring(5,value.indexOf("-"));
                        var selection = value.substring(value.indexOf("-") + 1 );
                        arrDesc.push(track + " Race " + racenum + " [ " + selection + " ]");
                    });
                }
            }
            return arrDesc;
        }

        function getOrientation() {
            return $window.orientation == 0 || $window.orientation == 180 || $window.orientation == undefined ? false : true;
        }

        angular.element($window).bind('orientationchange', function () {
            vm.isLand = getOrientation();
            vm.isDesktop = ($window.orientation==null)?true:false;
        });
    }
})();

class PendingWagerSymbol {
    public static TYPE_SPREAD:string = "S";
    public static TYPE_MONEY_LINE:string = "M";
    public static TYPE_TOTAL:string = "L";
    public static TYPE_TEAM_TOTAL:string = "E";

    public static OUTCOME_PENDING:string = "P";
    public static OUTCOME_WIN:string = "W";
    public static OUTCOME_LOSS:string = "L";
    public static OUTCOME_CANCELLED:string = "X";
}